import { render, staticRenderFns } from "./like.vue?vue&type=template&id=5406aa47&"
import script from "./like.vue?vue&type=script&lang=js&"
export * from "./like.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5406aa47')) {
      api.createRecord('5406aa47', component.options)
    } else {
      api.reload('5406aa47', component.options)
    }
    module.hot.accept("./like.vue?vue&type=template&id=5406aa47&", function () {
      api.rerender('5406aa47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/like.vue"
export default component.exports